import { CurrencyProvider } from '../src/components/CurrencyProvider/CurrencyProvider';

export { CurrencyProvider };
